export const ensureSortByIsSet = (params, options) => {
  const isSet = options.some(option => option.value === params.sortBy);
  return { ...params, sortBy: isSet ? params.sortBy : options[0].value };
};
